// import React from 'react';
// import {
//    Box,
//    Flex,
//    Text,
//    Icon,
//    VStack,
//    HStack,
//    Divider,
//    Scrollbar,
//    useColorModeValue,
//    Card,
//    CardHeader,
//    Heading,
// } from '@chakra-ui/react';
// import { formatAmountWithLabel } from 'utils/util';

// const BankAccountsCard = ({ height, data }) => {
//    const cardBg = useColorModeValue('white', 'gray.700');
//    const textColor = useColorModeValue('gray.800', 'white');
//    const amountColor = useColorModeValue('blue.600', 'blue.300');
//    const iconColor = useColorModeValue('teal.500', 'teal.300');
//    const scrollbarThumb = useColorModeValue('gray.400', 'gray.500');
//    const scrollbarTrack = useColorModeValue('gray.100', 'gray.700');

//    // Calculate totalAmount correctly
//    const totalAmount = data.reduce((acc, account) => acc + Number(account.closingbal || 0), 0);

//    return (
//       <Card h={height} width={'100%'}>
//          <CardHeader>
//             <Heading size="md">
//                <HStack justifyContent="space-between">
//                   <Flex direction={'column'} alignItems={'start'} justifyContent={'center'}>
//                      <Box>Bank Accounts</Box>
//                      <Box fontWeight="normal" fontSize="18px" color={textColor}>
//                         {formatAmountWithLabel(totalAmount)}
//                      </Box>
//                   </Flex>
//                </HStack>
//             </Heading>
//          </CardHeader>

//          {/* Scrollable accounts list */}
//          <Box
//             flex="1"
//             overflowY="auto"
//             p={'5%'}
//             pr={1} // Add padding so content doesn't hide behind scrollbar
//             sx={{
//                '::-webkit-scrollbar': {
//                   width: '8px',
//                },
//                '::-webkit-scrollbar-track': {
//                   backgroundColor: scrollbarTrack,
//                   borderRadius: 'full',
//                },
//                '::-webkit-scrollbar-thumb': {
//                   backgroundColor: scrollbarThumb,
//                   borderRadius: 'full',
//                   '&:hover': {
//                      backgroundColor: useColorModeValue('gray.500', 'gray.400'),
//                   },
//                },
//             }}>
//             <VStack spacing={0} align="stretch">
//                {data.map((account, index) => (
//                   <Box key={index}>
//                      <HStack justifyContent="space-between" py={3} px={1}>
//                         <HStack>
//                            <Text fontSize="lg" color={textColor}>
//                               {account.name}
//                            </Text>
//                         </HStack>
//                         <HStack>
//                            {/* <Icon as={FaPhone} color={iconColor} boxSize={4} /> */}
//                            <Text fontSize="lg" fontWeight="medium" color={account.closingbal < 0 ? 'green.500' : 'red.500'}>
//                               {formatAmountWithLabel(account.closingbal)}
//                            </Text>
//                         </HStack>
//                      </HStack>
//                      {index < data.length - 1 && <Divider />}
//                   </Box>
//                ))}
//             </VStack>
//          </Box>
//       </Card>
//    );
// };

// export default BankAccountsCard;

import React, { useState } from 'react';
import { useColorMode } from '@chakra-ui/react';
import { Building2, TrendingUp, TrendingDown, RotateCw } from 'lucide-react';
import { formatAmountWithLabel } from 'utils/util';
import { BsBank, BsCash } from 'react-icons/bs';
import { getCashAndBankBalance } from '../../../../redux/actions/dashboard';
import { useDispatch } from 'react-redux';

const BankAccountsCard = ({ height, data, financialAnalysisDateRange, user }) => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const [isRotating, setIsRotating] = useState(false);
   const dispatch = useDispatch();

   // Calculate totalAmount correctly
   const totalAmount = data.reduce((acc, account) => acc + Number(account.closingbal || 0), 0);

   const handleReload = async () => {
      setIsRotating(true);
      dispatch(
         getCashAndBankBalance({
            companyId: user?.loginhistory?.companyId,
            fromDate: financialAnalysisDateRange.fromDate,
            toDate: financialAnalysisDateRange.toDate,
         }),
      );
      setTimeout(() => setIsRotating(false), 700);
   };

   return (
      <div
         className={`${isDark ? 'bg-gradient-to-br from-gray-800 to-gray-900' : 'bg-gradient-to-br from-white to-gray-50'
            } rounded-2xl shadow-xl w-full border ${isDark ? 'border-gray-700' : 'border-gray-200'} overflow-hidden`}
         style={{ height }}>
         {/* Card Header with enhanced design */}
         <div className={`p-4 border-b ${isDark ? 'border-gray-700 bg-gray-800/50' : 'border-gray-200 bg-blue-50/30'}`}>
            <div className="flex justify-between items-center">
               <div className="flex items-center gap-3">
                  <div className={`p-2 rounded-xl ${isDark ? 'bg-blue-500/20' : 'bg-blue-500/10'}`}>
                     <Building2 className={`w-5 h-5 ${isDark ? 'text-blue-400' : 'text-blue-600'}`} />
                  </div>
                  <div>
                     <h2 className={`text-lg font-bold ${isDark ? 'text-white' : 'text-gray-800'}`}>
                        Cash/Bank Accounts
                     </h2>
                     <p className={`text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                        {data.length} {data.length === 1 ? 'Account' : 'Accounts'}
                     </p>
                  </div>
               </div>
               <div className="flex items-center gap-3">
                  <div className="flex flex-col items-end">
                     <p className={`text-xs font-medium ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                        Total Balance
                     </p>
                     <div
                        className={`text-xl font-bold ${totalAmount > 0
                              ? isDark
                                 ? 'text-red-400'
                                 : 'text-red-600'
                              : isDark
                                 ? 'text-green-400'
                                 : 'text-green-600'
                           }`}>
                        {formatAmountWithLabel(totalAmount)} {totalAmount > 0 ? 'CR' : 'DB'}
                     </div>
                  </div>
                  <button
                     onClick={handleReload}
                     className={`p-2 rounded-full transition-all duration-300 hover:scale-110 ${isDark ? 'hover:bg-gray-700 text-blue-400' : 'hover:bg-gray-100 text-blue-600'
                        }`}>
                     <RotateCw
                        className={`w-5 h-5 transform ${isRotating ? 'rotate-[360deg]' : ''
                           } transition-transform ease-in-out`}
                        style={{
                           transitionDuration: isRotating ? '700ms' : '10ms',
                        }}
                     />
                  </button>
               </div>
            </div>
         </div>

         {/* Scrollable accounts list with improved design */}
         <div
            className="overflow-y-auto p-4"
            style={{
               height: `calc(${height} - 140px)`,
               scrollbarWidth: 'thin',
               scrollbarColor: isDark ? '#4B5563 #1F2937' : '#D1D5DB #F3F4F6',
            }}>
            <style jsx>{`
               div::-webkit-scrollbar {
                  width: 6px;
               }
               div::-webkit-scrollbar-track {
                  background-color: ${isDark ? '#1F2937' : '#F3F4F6'};
                  border-radius: 10px;
               }
               div::-webkit-scrollbar-thumb {
                  background-color: ${isDark ? '#4B5563' : '#D1D5DB'};
                  border-radius: 10px;
               }
               div::-webkit-scrollbar-thumb:hover {
                  background-color: ${isDark ? '#6B7280' : '#9CA3AF'};
               }
            `}</style>

            <div className="flex flex-col gap-2">
               {data.map((account, index) => (
                  <div
                     key={index}
                     className={`group p-4 rounded-xl transition-all duration-200 ${isDark
                           ? 'bg-gray-800/50 hover:bg-gray-700/50 border border-gray-700 hover:border-gray-600'
                           : 'bg-white hover:bg-gray-50 border border-gray-200 hover:border-gray-300 shadow-sm hover:shadow-md'
                        }`}>
                     <div className="flex justify-between items-center">
                        <div className="flex items-center gap-3 flex-1">
                           <div className={`p-2 rounded-lg ${isDark ? 'bg-teal-500/10' : 'bg-teal-500/10'}`}>
                              {account.type === 'CASH' ? (
                                 <BsCash className={`w-5 h-5 ${isDark ? 'text-teal-400' : 'text-teal-600'}`} />
                              ) : (
                                 <BsBank className={`w-5 h-5 ${isDark ? 'text-orange-400' : 'text-orange-600'}`} />
                              )}
                           </div>
                           <div className="flex flex-col">
                              <span className={`text-base font-semibold ${isDark ? 'text-white' : 'text-gray-800'}`}>
                                 {account.name}
                              </span>
                              <span className={`text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                                 {account.closingbal > 0 ? 'Credit Balance' : 'Debit Balance'}
                              </span>
                           </div>
                        </div>

                        <div className="flex flex-col items-end">
                           <span
                              className={`text-lg font-bold transition-colors ${account.closingbal > 0
                                    ? isDark
                                       ? 'text-red-400'
                                       : 'text-red-600'
                                    : isDark
                                       ? 'text-green-400'
                                       : 'text-green-600'
                                 }`}>
                              {formatAmountWithLabel(account.closingbal)} {account.closingbal > 0 ? 'CR' : 'DB'}
                           </span>
                           <div
                              className={`mt-1 h-1 rounded-full transition-all duration-200 ${account.closingbal > 0
                                    ? 'bg-gradient-to-r from-red-500 to-red-400 w-0 group-hover:w-16'
                                    : 'bg-gradient-to-r from-green-500 to-green-400 w-0 group-hover:w-16'
                                 }`}
                           />
                        </div>
                     </div>
                  </div>
               ))}

               {data.length === 0 && (
                  <div className={`text-center py-12 ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                     <Building2 className="w-12 h-12 mx-auto mb-3 opacity-50" />
                     <p className="text-lg font-medium">No bank accounts found</p>
                     <p className="text-sm mt-1">Add accounts to see them here</p>
                  </div>
               )}
            </div>
         </div>
      </div>
   );
};

export default BankAccountsCard;
